<template>
    <div class="col-sm-6 col-md-6">
        <h2>{{ aboutsundair[getCurrentLocale] }}</h2>
        <p>
            <strong>European Air Charter</strong> <span v-html="aboutsundairtext[getCurrentLocale]"></p>
        <br />
        <address class="contact-details">
            <span class="contact-phone">
                <i class="soap-icon-message"></i> Air41</span>
            <br />
            <a href="mailto:info@air41.de" class="contact-email">info@air41.de</a>
        </address>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                aboutsundair: {
                    en: 'About European Air Charter',
                    de: 'Über European Air Charter',
                },
                aboutsundairtext: {
                    en: ' is a Bulgarian airline founded in 2000. Its core business is operating charter flights for well-known European tour operators. European Air Charter flies primarily to the resorts of Varna and Burgas, both located on the Black Sea. The fleet includes 10 Airbus A320 aircraft.',
                    de: ' ist eine bulgarische Fluggesellschaft, die 2000 gegründet wurde. Das Kerngeschäft besteht in der Durchführung von Charterflügen für bekannte europäische Reiseveranstalter. European Air Charter fliegt vorrangig die Urlaubsorte Varna und Burgas an, die beide am Schwarzen Meer liegen. Die Flotte umfasst 10 Maschinen vom Typ Airbus A320. ',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* AB3B7A */
</style>


// WEBPACK FOOTER //
// src/components/shared/footer/ThirdRow.vue